import edgeCommon from '../common';

let payment = (function () {
    let addValidations = function() {

        $("#update-record-payment").validate({
            ignore: "",
            errorClass: "text-danger",
            rules: {},
        });
    }
    let initPayment = function () {
        $(document).on("click", "#save-payment", function () {
            let addedCard = $("input[name='addedCard']:checked").val();
            $("#card-errors").html("");
            if ($("input[name='addedCard']:checked").length > 0) {
                let type = "new";
                if (addedCard == "newCard") {
                    $(".loading").removeClass("d-none");
                    stripe.createToken(card).then(function (result) {
                        $(".loading").addClass("d-none");
                        if (result.error) {
                            // Inform the customer that there was an error.
                            let errorElement = document.getElementById("card-errors");
                            errorElement.textContent = result.error.message;
                        } else {
                            // Send the token to your server.
                            stripeTokenHandler(result.token, type, "/order/charge", "");
                        }
                    });
                } else {
                    type = "exist";
                    stripeTokenHandler(addedCard, type, "/order/charge", "");
                }
            } else {
                $(".card-errors").text("Please add new card or select card");
            }
        });

        $(document).on("click", "#add-card", function () {
            $("#card-errors").html("");
            $(".loading").removeClass("d-none");
            
            stripe.createToken(card).then(function (result) {
                $(".loading").addClass("d-none");
                if (result.error) {
                    // Inform the customer that there was an error.
                    let errorElement = document.getElementById("card-errors");
                    errorElement.textContent = result.error.message;
                } else {
                    // Send the token to your server.
                    let token = result.token;
                    let setDefault = $("#set-default").prop("checked");
                    $(".loading").removeClass("d-none");
                    $.ajax({
                        url: baseUrl + "/add-card",
                        type: "POST",
                        dataType: "JSON",
                        data: { token, setDefault },
                        success: function (response) {
                            $(".loading").addClass("d-none");
                            if (response.status == "success") {
                                edgeCommon.swalSuccess(response.message).then(() => {
                                    window.location.href = baseUrl + "/my-cards";
                                });
                            } else {
                                edgeCommon.swalError(response.message);
                            }
                        },
                    });
                }
            });
        });

        let stripeTokenHandler = (token, type, url, orderUuid) => {
            $(".loading").removeClass("d-none");
            $.ajax({
                url: baseUrl + url,
                type: "POST",
                dataType: "JSON",
                data: { token, type, orderUuid },
                success: function (response) {
                    $(".loading").addClass("d-none");
                    if (response.status == "success") {
                        edgeCommon.swalSuccess(response.message).then((result) => {
                            if (result) {
                                let redirectUrl = orderUuid ? baseUrl + "/billing" : baseUrl + "/billing?msg=thank-you";
                                window.location.href = redirectUrl;
                            }
                        });
                    } else {
                        edgeCommon.swalError(response.message);
                    }
                },
                error: function (xhr) {
                    $(".loading").addClass("d-none");
                    let err = eval("(" + xhr.responseText + ")");
                    edgeCommon.swalError(err.message);
                },
            });
        };

        $(document).on("click", ".addedCard", function () {
            $(this).val() == "newCard" ? $("#card-element").removeClass("d-none") : $("#card-element").addClass("d-none");
        });

        $(document).on("change", ".set_default", function () {
            let checked = $(this);
            let id = $(this).data("id");

            Swal.fire({
                title: "Are you sure?",
                text: "You want to set this card as an active card",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, Do it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    $(".loading").removeClass("d-none");
                    $.ajax({
                        url: baseUrl + "/set-default-card",
                        type: "POST",
                        dataType: "JSON",
                        data: { id: id },
                        success: function (response) {
                            $(".loading").addClass("d-none");
                            if (response.status == "success") {
                                edgeCommon.swalSuccess(response.message);
                                $(".set_default").prop("checked", false);
                                $(checked).prop("checked", true);
                            } else {
                                edgeCommon.swalError(response.message);
                                $(checked).prop("checked", false);
                            }
                        },
                    });
                } else {
                    $(this).prop("checked", !$(this).prop("checked"));
                }
            });
        });

        $(document).on("click", ".remove-card", function () {
            let id = $(this).data("id");

            Swal.fire({
                title: "Are you sure?",
                text: "You want to remove this card",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, Do it!",
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    $(".loading").removeClass("d-none");
                    $.ajax({
                        url: baseUrl + "/remove-card",
                        type: "POST",
                        dataType: "JSON",
                        data: { id: id },
                        success: function (response) {
                            $(".loading").addClass("d-none");
                            if (response.status == "success") {
                                edgeCommon.swalSuccess(response.message).then(() => {
                                    window.location.reload();
                                });
                            } else {
                                edgeCommon.swalError(response.message);
                            }
                        },
                    });
                }
            });
        });

        $(document).on("click", ".payment-active-status", function () {
            let newStatus = "";
            let newStatusLabel = "";
            let currentStatusLabel = "";
            let id = [];
            id.push($(this).data("userid"));
            if ($(this).prop("checked")) {
                newStatus = "paymentActive";
                newStatusLabel = "active";
                currentStatusLabel = "inactive";
            } else {
                newStatus = "paymentInactive";
                newStatusLabel = "inactive";
                currentStatusLabel = "active";
            }
            Swal.fire({
                title: "Are you sure?",
                text: "You want to change user payment status " + currentStatusLabel + " to " + newStatusLabel,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, Do it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    $(".loading").removeClass("d-none");
                    $.ajax({
                        url: baseUrl + "/admin/users/user-actions",
                        type: "POST",
                        dataType: "JSON",
                        data: { user_action: newStatus, user_ids: id },
                        success: function (response) {
                            $(".loading").addClass("d-none");
                            if (response.status) {
                                edgeCommon.swalSuccess(response.message + " to " + newStatusLabel).then(() => {
                                    window.location.reload();
                                });
                            }
                        },
                    });
                } else {
                    $(this).prop("checked", !$(this).prop("checked"));
                }
            });
        });

        $(document).on("click", "#payment", function () {
            let orderUuid = $("#order-uuid").val();
            
            let addedCard = $("input[name='addedCard']:checked").val();
            $("#card-errors").html("");
            if ($("input[name='addedCard']:checked").length > 0) {
                let type = "new";
                if (addedCard == "newCard") {
                    $(".loading").removeClass("d-none");
                    
                    stripe.createToken(card).then(function (result) {
                        $(".loading").addClass("d-none");
                        if (result.error) {
                            // Inform the customer that there was an error.
                            let errorElement = document.getElementById("card-errors");
                            errorElement.textContent = result.error.message;
                        } else {
                            // Send the token to your server.
                            stripeTokenHandler(result.token, type, "/payment", orderUuid);
                        }
                    });
                } else {
                    type = "exist";
                    stripeTokenHandler(addedCard, type, "/payment", orderUuid);
                }
            } else {
                $(".card-errors").text("Please add new card or select card");
            }
        });

        $(document).on("click", "#process-order", function () {
            $(".loading").removeClass("d-none");
            $.ajax({
                url: baseUrl + "/admin/users/process-order",
                type: "POST",
                dataType: "JSON",
                success: function (response) {
                    $(".loading").addClass("d-none");
                    if (response.status) {
                        edgeCommon.swalSuccess(response.message).then(() => {
                            window.location.href = baseUrl + "/billing";
                        });
                    }
                },
            });
        });

        $(document).on("click", "#process-site-authorized", function () {
            $(".loading").removeClass("d-none");
            $.ajax({
                url: baseUrl + "/site/authorized",
                type: "POST",
                dataType: "JSON",
                success: function (response) {
                    $(".loading").addClass("d-none");
                    if (response.status) {
                        edgeCommon.swalSuccess(response.message).then(() => {
                            window.location.href = baseUrl + "/strongboxes";
                        });
                    }
                },
            });
        });

        
        $(document).on("click", "#request-manual-payment", function () {
            $(".loading").removeClass("d-none");
            $.ajax({
                url: baseUrl + "/admin/users/request-manual-payment",
                type: "GET",
                dataType: "JSON",
                success: function (response) {
                    $(".loading").addClass("d-none");
                    if (response.status) {
                        edgeCommon.swalSuccess(response.message).then(() => {
                            window.location.href = baseUrl + "/strongboxes";
                        });
                    }
                },
            });
        });

        $(document).on('click', '.change-record-payment', function(){
            let id = $(this).data('id');
            $.ajax({
                url: baseUrl + '/admin/recordPayment/edit',
                type: 'GET',
                data: { uuid: id },
                success:function(response) {
                    if(response.order) {
                        $('#paymentRecordModal').modal('toggle');
                        $('#order_uuid').val(response.order.uuid);
                        $('#payment_status').val(response.order.status);
                        $('#ref_details').val(response.order.ref_details);
                        $('#notes').val(response.order.notes);
                    }
                }
            });
        });

        $('#save-record-payment').click(function() {
            if($('#update-record-payment').valid()) {
                $(".loading").removeClass('d-none');
                let formData = new FormData($( '#update-record-payment' )[0]); 
                $.ajax({
                    url: baseUrl + '/admin/users/update-record-payment',
                    type: 'POST',  
                    data: formData,  
                    async: false,  
                    cache: false,  
                    contentType: false,  
                    processData: false,
                    success:function(response) {
                        $(".loading").addClass('d-none');
                        Swal.fire({
                            title: 'Success',
                            text: response.message,
                            type: 'success',
                            icon: 'success',
                        }).then((result) => {
                            if (result.isConfirmed) {
                                $('#paymentModeModal').modal('toggle');
                                window.location.reload();
                            }
                        });
                    }
                });
            }
        });

        $(document).on('click', '.process_order_payment', function(){
            let val = $(this).val();
            if(val == 'manual') {
                $('.creditCardDiv').hide();
                $('.manualDiv').show();
            } else {
                $('.creditCardDiv').show();
                $('.manualDiv').hide();
            }
        });
        $('.creditCardDiv').show();
        $('.manualDiv').hide();
        
    };

    return {
        // public functions
        init: function () {
            addValidations();
            initPayment();
        },
    };
})();

$(document).ready(function () {
    payment.init();
});

const stripe = Stripe(stripe_key);

let style = {
    base: {
        // Add your base input styles here. For example:
        fontSize: "15px",
        color: "#32325d",
    },
};

let elements = stripe.elements();
// Create an instance of the card Element.
let card = elements.create("card", { style: style });

// Add an instance of the card Element into the `card-element` <div>.
if (document.getElementById("card-element")) {
    card.mount("#card-element");
}
